/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { DASHBOARD } from "constants/ApiRoutes";
import { useEffect, useState } from "react";
import api from "api/api";
import DashboardCard from "components/DashboardCard";
import MDModal from "components/MDModal";
import { Typography } from "@mui/material";

function Dashboard() {
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { sales, tasks } = reportsLineChartData;

  const orders = {
    labels: Object.keys(data?.last_five_months_orders || {}),
    datasets: {
      label: "Transações",
      data: Object.values(data?.last_five_months_orders || {}),
    },
  };

  // const properties = {
  //   labels: Object.keys(data?.last_five_months_properties || {}),
  //   datasets: { label: "Imoveis", data: Object.values(data?.last_five_months_properties || {}) },
  // };

  const customers = {
    labels: Object.keys(data?.last_five_months_customers || {}),
    datasets: { label: "Clientes", data: Object.values(data?.last_five_months_customers || {}) },
  };

  const dataDashboard = async () => {
    await api.get(DASHBOARD).then((response) => {
      setData(response.data);
    });
  };

  // const chooseTenant = <></>;

  useEffect(() => {
    dataDashboard();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          {/* <DashboardCard
            icon="paid"
            color="dark"
            title="Comissões Atuais"
            data={data.month_commissions}
            percentage={{
              color: "dark",
              label: "no mês atual",
            }}
          /> */}
          <DashboardCard
            icon="leaderboard"
            title="Ordens Finalizadas"
            data={data.orders_completed_by_month}
            percentage={{
              color: "dark",
              label: "no mês atual",
            }}
          />
          {/* <DashboardCard
            color="success"
            icon="apartment"
            title="Novos Imóveis Cadastrados"
            data={data.new_properties_by_month}
            percentage={{
              color: "dark",
              label: "no mês atual",
            }}
          /> */}
          <DashboardCard
            color="warning"
            icon="person_add"
            title="Novos Clientes"
            data={data.new_customers_by_month}
            percentage={{
              color: "dark",
              label: "no mês atual",
            }}
          />
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="Ordens"
                  description="Ordens Finalizadas nos últimos 6 meses"
                  date="atualizado"
                  chart={orders}
                />
              </MDBox>
            </Grid>
            {/* <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="success"
                  title="ímoveis cadastrados"
                  description={
                    <>
                      <strong>Ímoveis Cadastrados</strong> nos 6 últimos meses.
                    </>
                  }
                  date="atualizado"
                  chart={properties}
                />
              </MDBox>
            </Grid> */}
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="warning"
                  title="clientes cadastrados"
                  description="Clientes cadastrados nos últimos 6 meses"
                  date="atualizado"
                  chart={customers}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
      {/* <MDModal isOpen={isOpen} handleModal={handleModal}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {msg}
        </Typography>
      </MDModal> */}
    </DashboardLayout>
  );
}

export default Dashboard;
